module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('isrs-parcel-number-select', {
    attrs: {
      "parcelNumberContainerId": _vm.returnShopPortal.parcelNumberContainerId,
      "parcelnumbercontainers": _vm.parcelnumbercontainers
    },
    on: {
      "change": function (id) { return _vm.saveParcelNumberContainer(id); }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-0d3e3393"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/ParcelNumberContainers.vue
// module id = 919
// module chunks = 1